import { number, node, any, bool } from 'prop-types';
import Link from 'next/link';
import { Spin } from 'antd';

import { categories } from 'utils/myaccount';
import { useI18n } from 'context/i18n';
import { useUser } from 'context/user';
import { MyAccountFormWrapper } from 'components/myAccount';

import styles from './style.module.css';
import { IS_NNORMAL } from 'utils/constants/system';

export default function MyAccountLayout({
  children,
  activePanel,
  contentClassName = null,
  withCategories = true,
  withAuth = true,
  withCategoriesLayout = true,
  formWrapperStyles,
}) {
  const { t, locale } = useI18n();
  const { userData, loading, shouldLogin } = useUser();

  if (withAuth && userData === null) {
    return (
      <Spin spinning={loading}>
        <div className={!formWrapperStyles ? styles.layoutLogin : `${styles.layoutLogin} ${formWrapperStyles}`}>
          {!shouldLogin ?
            <p className={styles.authenticating}>{t('mi.cuenta', 'autentificando', 'Authenticating...')}</p>
          : <MyAccountFormWrapper
              locale={locale}
              onSuccess={() => {
                window.location.assign(`${window.location.origin}/${locale}/myaccount${IS_NNORMAL ? '/nnormal-world' : ''}`);
              }}
            />
          }
        </div>
      </Spin>
    );
  }

  if (!withCategoriesLayout) {
    return <>{children}</>;
  }

  return (
    <div className={styles.layoutContainer}>
      <nav className={styles.nav}>
        {withCategories && (
          <ul>
            <li key="Home" className={styles.navItem}>
              <a href={`/${locale}/myaccount${IS_NNORMAL ? '/nnormal-world' : ''}`}>{t('mi.cuenta', 'home', 'Home')}</a>
            </li>
            {categories
              .filter((item) => (item.condition ? item.condition(userData) : true))
              .map((category, index) => (
                <li key={category.title} className={index !== activePanel ? styles.navItem : `${styles.navItem} ${styles.navItemActive}`}>
                  {category.link ?
                    <Link shallow={true} href={`/${locale}${category.link}`}>
                      {t(...category.title)}
                    </Link>
                  : t(...category.title)}
                </li>
              ))}
          </ul>
        )}
      </nav>
      <div className={contentClassName ? `${contentClassName} ${styles.content}` : styles.content}>{children}</div>
    </div>
  );
}

MyAccountLayout.propTypes = {
  children: node,
  activePanel: number,
  contentClassName: any,
  withCategories: bool,
  withAuth: bool,
  withCategoriesLayout: bool,
  formWrapperStyles: any,
};
